import { Number3 } from '@fabric-web/3d-viewer';
import { useCallback } from 'react';
import { useAtom, useAtomValue } from 'jotai';
import * as localState from '@/components/Analysis/state';
import * as poiState from './state';
import { PointOfInterestDocument } from '@/types';
import { useGetStructureId } from '@/hooks/useGetStructureId';
import { PointOfInterestTemplateTypeEnum } from '@/__generated__/graphql';

export const useHandlePoiClick = () => {
  const [editPointOfInterest, setEditPointOfInterest] = useAtom(poiState.editPointOfInterest);
  const blisterToAdd = useAtomValue(poiState.blisterToAdd);

  const selectedAssemblyId = useAtomValue(localState.selectedAssemblyId);
  const selectedSpherical = useAtomValue(localState.selectedSpherical);
  const structureId = useGetStructureId();

  const handlePOIClick = useCallback(
    (point: Number3): boolean => {
      if (
        editPointOfInterest.state === 'WaitingForPoint' &&
        selectedAssemblyId &&
        structureId &&
        !blisterToAdd
      ) {
        const [x, y, z] = selectedSpherical?.position || [point[0], point[1], point[2]];
        const newPointOfInterest = {
          centerPoint3d: { x: point[0], y: point[1], z: point[2] },
          cameraLocation: {
            x,
            y,
            z,
          },
          type: 'OTHER',
          name: '', // TODO Next PI. Add Naming capability
          location: { id: selectedSpherical?.id! },
          assembly: { id: selectedAssemblyId, structure: { id: structureId } },
        };
        setEditPointOfInterest((current) => ({
          ...current,
          state: 'WaitingForTransition',
          pointOfInterest: newPointOfInterest as PointOfInterestDocument,
        }));
        setTimeout(() => {
          setEditPointOfInterest((current) => ({
            ...current,
            state: 'WaitingForDetail',
            formState:
              current.template?.type === PointOfInterestTemplateTypeEnum.VolumeOfInterest
                ? 'Resizing-VOI'
                : 'Create',
            pointOfInterest: newPointOfInterest as PointOfInterestDocument,
          }));
        }, 800);
        return true;
      }
      return false;
    },
    [
      editPointOfInterest.state,
      selectedAssemblyId,
      structureId,
      blisterToAdd,
      selectedSpherical?.position,
      selectedSpherical?.id,
      setEditPointOfInterest,
    ]
  );

  return handlePOIClick;
};
